import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class JobTest {
	/**
	 * @path /pages/:pgid/positions/:pid/job-test
	 * @param pid
	 * @returns
	 */
	async getAllJobTests(pgid: PGSchema.pages["id"], pid: PGSchema.jobs["job_id"], token: string) {
		return xget<{ job_tests: PGSchema.jobs_tests[] }>(`/pages/${pgid}/positions/${pid}/job-tests`, {}, { headers: { "app-token": token! } });
	}

	async getJobTestById(pgid: PGSchema.pages["id"], pid: PGSchema.jobs["job_id"], testId: number, token: string) {
		return xget<{ job_test: PGSchema.jobs_tests }>(`/pages/${pgid}/positions/${pid}/job-tests/${testId}`, {}, { headers: { "app-token": token! } });
	}

	async updateJobOptionsTest(pgid: PGSchema.pages["id"], pid: PGSchema.jobs["job_id"], testId: number, options: PGSchema.jobs_tests["options"], active: boolean, token: string) {
		return xhttp<{ job_test: PGSchema.jobs_tests }>(`/pages/${pgid}/positions/${pid}/job-tests/${testId}`, "PUT", { options, active }, { headers: { "app-token": token! } });
	}

	async migrateJobTest(pgid: PGSchema.pages["id"], pid: PGSchema.jobs["job_id"], profilesIds: string[], token: string) {
		return xhttp<{ job_test: PGSchema.jobs_tests }>(
			`/pages/${pgid}/positions/${pid}/job-tests/migrate`,
			"POST",
			{
				profiles_ids: profilesIds
			},
			{ headers: { "app-token": token! } }
		);
	}

	async deleteJobTest(pgid: PGSchema.pages["id"], pid: PGSchema.jobs["job_id"], testId: number, token: string) {
		return xhttp<{ job_test: PGSchema.jobs_tests }>(`/pages/${pgid}/positions/${pid}/job-tests/${testId}`, "DELETE", { headers: { "app-token": token! } });
	}

	async createJobTest(pgid: PGSchema.pages["id"], pid: PGSchema.jobs["job_id"], test: PGSchema.jobs_tests, token: string) {
		return xhttp<{ job_test: PGSchema.jobs_tests }>(`/pages/${pgid}/positions/${pid}/job-tests`, "POST", { test }, { headers: { "app-token": token! } });
	}
}
